module.exports = __webpack_public_path__ + "img/placeholder-testimoni.fc69544d.png";